import { useAuth0 } from '@auth0/auth0-react';
import { LoadingSpinner } from './LoadingSpinner';
import { LoginPage } from './LoginPage';
import { type ReactNode } from 'react';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
